import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1663.89761 L1920,1791.88907 L255.982934,1791.88907 L255.982934,1663.89761 L1920,1663.89761 Z M1919.87201,1279.92321 L1919.87201,1407.91467 L0,1407.91467 L0,1279.92321 L1919.87201,1279.92321 Z M1920,895.948803 L1920,1023.94027 L255.982934,1023.94027 L255.982934,895.948803 L1920,895.948803 Z M1919.87201,511.974402 L1919.87201,639.965869 L0,639.965869 L0,511.974402 L1919.87201,511.974402 Z M1920,128 L1920,255.991467 L255.982934,255.991467 L255.982934,128 L1920,128 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextEndLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextEndLine, _Component);

  var _super = _createSuper(IconTextEndLine);

  function IconTextEndLine() {
    _classCallCheck(this, IconTextEndLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextEndLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextEnd",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconTextEndLine.displayName = "IconTextEndLine";
  return IconTextEndLine;
}(Component);

IconTextEndLine.glyphName = 'text-end';
IconTextEndLine.variant = 'Line';
IconTextEndLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextEndLine;
export { IconTextEndLine };